import { Controller } from "@hotwired/stimulus"

// Like select2-autosubmit, but also stamps a `select2-value--{value}` class
// on each selected chip so CSS can color chips by their option value.
export default class extends Controller {
  connect() {
    const options = this.element.dataset.options ? JSON.parse(this.element.dataset.options) : {}

    const element = this.element
    $(this.element).select2({
      theme: "bootstrap",
      placeholder: this.element.dataset.placeholder || "Select...",
      allowClear: true,
      width: "100%",
      templateResult: (data) => {
        const selectedIds = new Set(Array.from(element.selectedOptions).map((o) => o.value))
        return selectedIds.has(String(data.id)) ? null : data.text
      },
      ...options,
    })

    $(this.element).on("change.select2", () => {
      this.#sortChips()
      this.#colorChips()
      if (this.element.dataset.preserveUrlSyncing === "true") return
      const form = this.element.closest("form")
      if (form) form.requestSubmit()
    })

    this.#sortChips()
    this.#colorChips()
  }

  disconnect() {
    if ($(this.element).data("select2")) {
      $(this.element).select2("destroy")
    }
  }

  #sortChips() {
    const $rendered = $(this.element).data("select2").$container
      .find(".select2-selection__rendered")
    const $search = $rendered.find(".select2-search--inline")
    $rendered.find(".select2-selection__choice").toArray()
      .sort((a, b) => $(a).attr("title").localeCompare($(b).attr("title"), undefined, { sensitivity: "base" }))
      .forEach(el => $(el).insertBefore($search))
  }

  #colorChips() {
    const titleToValue = Object.fromEntries(
      Array.from(this.element.options).map((opt) => [opt.text, opt.value])
    )

    const $container = $(this.element).data("select2").$container
    $container.find(".select2-selection__choice").each(function () {
      const value = titleToValue[$(this).attr("title")]
      if (!value) return

      $(this).removeClass((_i, cls) => (cls.match(/\bselect2-value--\S+/g) || []).join(" "))
      $(this).addClass(`select2-value--${value}`)
    })
  }
}
